import React from "react";
import { Link } from "react-router-dom";

interface Props {}

const UnauthorizedAuth: React.FC<Props> = () => {
  return (
    <div className="bg-white min-h-screen px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
      <div className="flex max-w-max mx-auto">
        <p className="text-4xl font-extrabold text-indigo-600 sm:text-5xl">
          :(
        </p>
        <div className="sm:ml-6">
          <div className="sm:border-l sm:border-gray-200 sm:pl-6">
            <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
              Something went wrong.
            </h1>
            <p className="mt-1 text-base text-gray-500">
              Unfortunately something went wrong with the Discord authentication
              process.
            </p>
          </div>
          <div className="mt-6 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6">
            <Link
              to="/auth/discord"
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Try again
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedAuth;
